import { Injectable, inject } from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Observable, of} from 'rxjs';
import {map, catchError} from 'rxjs/operators';

import {AuthenticationService} from '../_services/authentication.service';
import {environment} from '@environments/environment';

@Injectable({providedIn: 'root'})
export class AuthGuard  {
  private router = inject(Router);
  private authenticationService = inject(AuthenticationService);


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    // Use the new async authorization method
    return this.authenticationService.isLoggedAsync().pipe(
      map((isLogged: boolean) => {
        if (isLogged) {
          return true;
        }
        // Redirect to external gateway login URL
        window.location.href = environment.loginUrl;
        return false;
      }),
      catchError(() => {
        // If there's an error, redirect to external gateway login URL
        window.location.href = environment.loginUrl;
        return of(false);
      })
    );
  }
}
